var typography = {
  headline: {
    fontWeight: 500,
    fontSize: '1.6875rem',
    lineHeight: '2rem',
    letterSpacing: 'normal',
    color: 'rgba(0, 0, 0, 0.87)',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
  },
  titleBig: {
    fontWeight: 500,
    fontSize: '1.125rem',
    lineHeight: '1.5rem',
    color: 'rgba(0, 0, 0, 0.87)',
    letterSpacing: 'normal',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
  },
  titleSmall: {
    fontWeight: 500,
    fontSize: '1rem',
    lineHeight: '1.5rem',
    color: 'rgba(0, 0, 0, 0.87)',
    letterSpacing: 'normal',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
  },
  body: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: '1.25rem',
    letterSpacing: 'normal',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
  },
  bodyLight: {
    color: 'rgba(0, 0, 0, 0.54)',
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: '1.25rem',
    letterSpacing: 'normal',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
  },
  bodyStrong: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: '1.25rem',
    letterSpacing: 'normal',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
  },
  caption: {
    color: 'rgba(0, 0, 0, 0.54)',
    letterSpacing: 'normal',
    lineHeight: 1.66,
    fontSize: '0.75rem',
    fontWeight: 400,
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
  },
  overline: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '0.75rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    lineHeight: 2.66,
    fontWeight: 400,
    letterSpacing: '0.08333rem',
    textTransform: 'uppercase'
  }
};
export default typography;